import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect } from "react";
import { fetchConfigurationDebounced } from "../actions/fetchConfiguration";
import { ConfigurationObjectContext } from "../context/ConfigurationObjectContext";
import { ConfigurationPathContext } from "../context/ConfigurationPathContext";
import { useConfigurationDispatch, useConfigurationSelector, } from "../context/ConfigurationReduxContext";
import { useSubscribeToPath } from "../hooks/useSubscribeToPath";
import { useUpdateSelectorDefaults } from "../hooks/useUpdateSelectorDefaults";
import { getCfgObjects } from "../reducers/selectors";
/**
 * Renders a sub configuration
 * @category Controller
 * @param props
 * @returns
 */
export function ConfigurationPathController(props) {
    const { path, children, FallbackUi = Fragment, persist = false } = props;
    const cfgObjects = useConfigurationSelector(getCfgObjects);
    const dispatch = useConfigurationDispatch();
    const updateSelectorDefaults = useUpdateSelectorDefaults();
    // find a matching configuration object that has attributes (is not a stub)
    const matchedCfgObject = cfgObjects.find((obj) => obj.path === props.path && obj.attributes != null);
    const isFound = matchedCfgObject != null;
    // manage selectors for the path
    useSubscribeToPath(path, persist);
    useEffect(() => {
        // add abortController to cancel the previous attempt
        const abortController = new AbortController();
        // trigger refetch when we do not have the object
        if (!isFound) {
            updateSelectorDefaults();
            dispatch(fetchConfigurationDebounced({ abortController }));
        }
        return () => {
            // cancel previous fetchConfigurationDebounced
            abortController.abort();
        };
    }, [isFound, dispatch, updateSelectorDefaults]);
    if (!matchedCfgObject) {
        return _jsx(FallbackUi, {});
    }
    return (_jsx(ConfigurationPathContext.Provider, { value: matchedCfgObject.path, children: _jsx(ConfigurationObjectContext.Provider, { value: matchedCfgObject, children: children }) }));
}
ConfigurationPathController.displayName = "ConfigurationPathController";
//# sourceMappingURL=ConfigurationPathController.js.map